import api from '@Services/api';
import {
	EducationAllData,
	EducationEntity,
	EducationSavePayload,
} from './education.types';

export const getEducationAll = async () =>
	await api.get<ApiResponse<EducationAllData>>('education/all');

export const createEducationEntity = async (
	entity: EducationEntity,
	payload: EducationSavePayload
) => await api.post(`education/${entity}/create`, payload);

export const updateEducationEntity = async (
	entity: EducationEntity,
	payload: EducationSavePayload
) => await api.put(`education/${entity}/update`, payload);

export const deleteEducationEntity = async (
	entity: EducationEntity,
	id: number
) => await api.delete(`education/${entity}/delete`, { data: { id } });
